import React, { useEffect, useRef } from 'react';
import { Icon } from '@pella/sash-framework';

const ToTop = () => {
	const topRef = useRef(null);

	useEffect(() => {
		document.addEventListener('scroll', onPageScroll, { passive: true });
		return () => {
			document.removeEventListener('scroll', onPageScroll, {
				passive: true,
			});
		};
	}, []);

	const onPageScroll = () => {
		if (!topRef.current) return;

		if (window.scrollY > 1000) topRef.current.style = 'opacity: 1; pointer-events: auto;';
		else topRef.current.style = '';
	};

	const onButtonClick = (e) => {
		e.preventDefault();
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	return (
		<div
			ref={topRef}
			className='pointer-events-none sticky bottom-0 z-[15] mx-auto h-[0px] max-w-[1568px] px-6 opacity-0 transition-all duration-300 md:px-8 xl:px-16'
		>
			<button
				onClick={(e) => onButtonClick(e)}
				className='ml-auto block h-12 w-12 -translate-y-12 bg-black pb-2.5 pt-1 text-center !leading-none text-white'
			>
				<Icon
					name='keyboard_arrow_up'
					className='block'
				/>
				<span className='block text-xs uppercase leading-none tracking-1px'>Top</span>
			</button>
		</div>
	);
};

export default ToTop;
